import { useState } from 'react'

import { type StepWizardChildProps } from 'react-step-wizard'
import styled from 'styled-components'

import VerificationPending from 'components/UI/Verification/VerificationPending'
import {
  VerificationFooter,
  VerificationPersonalInformationForm
} from 'components-ref/organisms/verification'
import { usePersonalInformationForm } from 'services/verification/usePersonalInformationForm'

import { VerificationContainer } from '../VerificationCountry/VerificationCountry'

export function VerificationPersonalInformation({
  currentStep,
  previousStep,
  verificationStep
}: Partial<StepWizardChildProps & { verificationStep: number }>) {
  const { formik, settingsValue } = usePersonalInformationForm()
  const [showPending, setShowPending] = useState(false)

  async function handleNextStep() {
    formik.setTouched(
      {
        firstName: true,
        lastName: true,
        country: true,
        address: true,
        city: true,
        stateProvince: true,
        postal: true,
        social: {
          twitter: true,
          instagram: true,
          other: true
        },
        dateOfBirth: true,
        documentType: settingsValue !== 1,
        idExpiration: settingsValue !== 1 && !formik.values.noExpiration,
        noExpiration: settingsValue !== 1,
        idPhotoUrl: settingsValue !== 1,
        idHoldPhotoUrl: settingsValue !== 1,
        agreeToCreatorTerms: true
      },
      true
    )

    const errors = await formik.validateForm()

    if (Object.keys(errors).length > 0) {
      return
    }

    try {
      await formik.submitForm()
      setShowPending(true)
    } catch (error) {
      console.error('[VerificationPersonalInformation] submit failed', error)
    }
  }

  if (showPending || verificationStep === 4) {
    return <VerificationPending />
  }

  return (
    <VerificationContainer>
      <StepHeader>
        <StepNumber>STEP 4</StepNumber>
        <SectionTitle>Personal Information</SectionTitle>
      </StepHeader>

      <VerificationPersonalInformationForm
        formik={formik}
        settingsValue={settingsValue}
      />

      <VerificationFooter
        currentStep={currentStep}
        previousStep={previousStep}
        nextStep={handleNextStep}
        nextDisabled={!formik.values.agreeToCreatorTerms || !formik.isValid || formik.isSubmitting}
      />
    </VerificationContainer>
  )
}

export const StepHeader = styled.div`
  text-align: center;
  margin-top: 2rem;
`

export const StepNumber = styled.p`
  color: #3b9ff9;
  font-size: 1.3rem;
  letter-spacing: 0.17em;
  text-transform: uppercase;
  font-weight: 500;
  margin: 0 0 1rem 0;
  line-height: 1.7rem;
`

export const SectionTitle = styled.h2`
  color: #181d3a;
  font-size: 2.2rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
`